// Lib Imports
import React, { useEffect, useCallback, useState } from 'react';
import { Box } from 'grommet';

// CORE Imports
import { useToast } from 'granite-admin/core/components/Toast';
import Loader from 'granite-admin/core/components/Loader';
import iframeApi from 'granite-admin/common/gateways/iframe-api';
const IframeComponent = () => {
  const {
    errorToast
  } = useToast();
  const [loader, setLoader] = useState(true);
  let authToken = '',
    organisationId = '';
  const validateUserHash = useCallback(async () => {
    let orgId = "hwzHVJimuy4Uu7EcPIv1qJ28ApI4ObCgqAAUMdGG",
      userHash = "$6$hwzHVJimuy4Uu7Ec$S9V7WlNT2djvE.SoTkauB/86BznjFlopuStc6dmXMRGuZaWY23FiyF.itc5Inp/eXMxAQm5YMDvkqmQyh1GE8.";
    let email = "mayank.shukla@thoughts2binary.com",
      APIbaseUrl = "https://api.angle42.com/angle42/v1/";
    try {
      const payload = {
        org_id: orgId,
        email: email,
        user_hash: userHash
      };
      let result = await iframeApi.validateUser(payload, APIbaseUrl);
      authToken = result.access_token;
      organisationId = result.organisation_id;
    } catch {
      errorToast('Unable to validate user hash');
    }
  }, [errorToast]);
  useEffect(() => {
    validateUserHash().then(res => {
      setLoader(false);
      var container = "app";
      var div = document.getElementById(container);
      var ifrm = document.createElement("iframe");
      ifrm.setAttribute("src", `https://lens.angle42.com/my-boards/3/Quivers%20Analytics/?oAuthToken=${authToken}&orgId=${organisationId}&route=/my-boards/3/Quivers%20Analytics&embed=true`);
      ifrm.style.flexGrow = "1";
      ifrm.setAttribute("frameBorder", "0");
      div.appendChild(ifrm);
    }).catch(err => errorToast('Unable to validate user hash'));
  }, [authToken, errorToast, validateUserHash]);
  return /*#__PURE__*/React.createElement(Box, {
    id: "app",
    flex: {
      grow: 1
    },
    margin: {
      horizontal: 'small',
      vertical: 'xsmall'
    }
  }, loader && /*#__PURE__*/React.createElement(Box, {
    flex: true,
    align: "center",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, null)));
};
export default IframeComponent;